export default "__VITE_ASSET__GvWw0oN9__"